import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const FeeStructure = () => {
  const homeMenu = [
    { label: "Admission Notification ", link: "/howtoapply" },
    { label: "Fee Structure", link: "/feestructure" },
    { label: "Prospectus ", link: "/Prospectus" },
    {
      label: "Virtual School Tour ",
      link: "https://iviewd.com/lotus_valley_gurgaon/",
    },
    { label: "School Schedule ", link: "/schoolSchedule" },
    {
      label: "Transport",
      link: "",
      subMenu: [
        { label: "Transport", link: "/transport" },
        { label: "Bus Routes", link: "/busRoute" },
      ],
    },

    { label: "Special Education", link: "/specialEdu" },
    { label: "Bonding With Parents", link: "/bondingwithparents" },
    // { label: "Career Counselling", link: "/careerCounselling" },
    {
      label: "Meal Menu",
      link: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/School-Menu.pdf",
    },
    { label: "CBSE Results", link: "/CBSEResult" },
    { label: "Transfer Certificate", link: "/tc" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/apply.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Fee Structure (2027-28)"
                breadEnd="Fee Structure"
                breadMid="Fee Structure"
              />
            </div>
          </div>

          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/fee_str_lvisgh.jpg"
            className="mx-auto d-block img-fluid"
          />
          {/* <div class="admission-table table fee">
            <table cellpadding="0" cellspacing="0" width="100%" border="1">
              <tbody>
                <tr>
                  <th colspan="2">PARTICULARS</th>
                  <th colspan="2">AMOUNT (Rs)</th>
                </tr>
                <tr>
                  <td colspan="2">
                    Admission Fee (One time payment) - Non Refundable
                  </td>
                  <td>99000</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td colspan="2">Caution Money - Refundable</td>
                  <td>30000</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td colspan="2">COMPOSITE FEE - (Subject to Change )</td>
                  <td>Monthly</td>
                  <td>Quarterly</td>
                </tr>
                <tr>
                  <td colspan="2">PN to Grade V</td>
                  <td>15500</td>
                  <td>46500</td>
                </tr>
                <tr>
                  <td colspan="2">Grade VI to VIII</td>
                  <td>16200</td>
                  <td>48600</td>
                </tr>
                <tr>
                  <td colspan="2">Grade IX &amp; X</td>
                  <td>16900</td>
                  <td>50700</td>
                </tr>
                <tr>
                  <td colspan="2">Grade XI &amp; XII (Commerce &amp; Arts)</td>
                  <td>17900</td>
                  <td>53700</td>
                </tr>
                <tr>
                  <td colspan="2">Grade XI &amp; XII (Science)</td>
                  <td>18900</td>
                  <td>56700</td>
                </tr>
                <tr>
                  <td colspan="2">Transport Fee (Optional )</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td colspan="2">Gurgaon</td>
                  <td>5500</td>
                  <td>16500</td>
                </tr>
                <tr>
                  <td colspan="2">
                    Delhi/ Palam Vihar/Kapashera Border/Manesar
                  </td>
                  <td>6500</td>
                  <td>19500</td>
                </tr>
                <tr>
                  <td colspan="4">
                    Payment of Fee within 2 days after confirmation of Admission
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <span>TOTAL</span>
                  </td>
                  <td>
                    <span>
                      With
                      <br />
                      Transport
                    </span>
                  </td>
                  <td>
                    <span>
                      Without
                      <br />
                      Transport
                    </span>
                  </td>
                </tr>
                <tr>
                  <td rowspan="2">PN TO V</td>
                  <td>Gurgaon</td>
                  <td>192000</td>
                  <td>175500</td>
                </tr>
                <tr>
                  <td>Delhi/Manesar</td>
                  <td>195000</td>
                  <td>175500</td>
                </tr>
                <tr>
                  <td rowspan="2">VI - VIII</td>
                  <td>Gurgaon</td>
                  <td>194100</td>
                  <td>177600</td>
                </tr>
                <tr>
                  <td>Delhi/Manesar</td>
                  <td>197100</td>
                  <td>177600</td>
                </tr>
                <tr>
                  <td rowspan="2">IX - X</td>
                  <td>Gurgaon</td>
                  <td>196200</td>
                  <td>179700</td>
                </tr>
                <tr>
                  <td>Delhi/Manesar</td>
                  <td>199200</td>
                  <td>179700</td>
                </tr>
                <tr>
                  <td rowspan="2">XI - XII ( Commerce &amp; Arts)</td>
                  <td>Gurgaon</td>
                  <td>199200</td>
                  <td>182700</td>
                </tr>
                <tr>
                  <td>Delhi/Manesar</td>
                  <td>202200</td>
                  <td>182700</td>
                </tr>
                <tr>
                  <td rowspan="2">XI - XII ( Science)</td>
                  <td>Gurgaon</td>
                  <td>202200</td>
                  <td>185700</td>
                </tr>
                <tr>
                  <td>Delhi/Manesar</td>
                  <td>205200</td>
                  <td>185700</td>
                </tr>
                <tr>
                  <td colspan="4">Registration Fee 2500/-(Non-Refunadable)</td>
                </tr>
                <tr>
                  <td colspan="4" style={{ textAlign: "center" }}>
                    P.S: IN CASE OF WITHDRAWAL
                    <br />
                    Notice period of 2 months required for refund of Caution
                    Money
                  </td>
                </tr>
              </tbody>
            </table>
          </div> */}
        </div>
      </div>
      <Footer />
    </>
  );
};
export default FeeStructure;
